import i18n from 'modules/core/lib/i18n'

export const VIRTUAL_BACKGROUND_TYPES = {
  DISABLED: 'disabled',
  BLUR: 'blur',
  BACKGROUND1: 'background1',
  BACKGROUND2: 'background2',
  BACKGROUND3: 'background3',
  BACKGROUND4: 'background4',
} as const

export const getVirtualBackgroundOptions = () => [
  {
    label: i18n.t('meetings.room.settings.blur_background.disabled'),
    value: VIRTUAL_BACKGROUND_TYPES.DISABLED,
  },
  {
    label: i18n.t('meetings.room.settings.blur_background.blur'),
    value: VIRTUAL_BACKGROUND_TYPES.BLUR,
  },
  {
    label: i18n.t('meetings.room.settings.blur_background.background1'),
    value: VIRTUAL_BACKGROUND_TYPES.BACKGROUND1,
  },
  {
    label: i18n.t('meetings.room.settings.blur_background.background2'),
    value: VIRTUAL_BACKGROUND_TYPES.BACKGROUND2,
  },
  {
    label: i18n.t('meetings.room.settings.blur_background.background3'),
    value: VIRTUAL_BACKGROUND_TYPES.BACKGROUND3,
  },
  {
    label: i18n.t('meetings.room.settings.blur_background.background4'),
    value: VIRTUAL_BACKGROUND_TYPES.BACKGROUND4,
  },
]
